import { render, staticRenderFns } from "./drugInfo.vue?vue&type=template&id=5443533e&"
import script from "./drugInfo.vue?vue&type=script&lang=js&"
export * from "./drugInfo.vue?vue&type=script&lang=js&"
import style0 from "./drugInfo.vue?vue&type=style&index=0&id=5443533e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports